import { useState, useEffect } from 'react';

const useRecommendedJobs = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRecommendedJobs = async () => {
      
      try {
        const url = `${process.env.REACT_APP_BACKEND_STAGING_URL}/api/jobs/top-rated-jobs-carousel`;
        
        const response = await fetch(url, {
          method: 'GET',
          credentials: 'include', 
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`Network response was not ok: ${response.status} - ${errorText}`);
        }

        const data = await response.json();
        
        setItems(data.data || []);
  
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchRecommendedJobs();
  }, []);

  return { items, loading, error };
};

export default useRecommendedJobs;
